webpackJsonp([144251824217401],{

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJss = __webpack_require__(3);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    circle: {
	      width: "300px",
	      height: "300px",
	      borderRadius: "150px",
	      display: "inline-block",
	      backgroundPosition: "center",
	      backgroundRepeat: "no-repeat",
	      backgroundSize: "contain",
	      fontSize: "1.5rem",
	      "@media (max-width: 823px)": {
	        width: "150px",
	        height: "150px",
	        borderRadius: "75px",
	        fontSize: "1rem"
	      },
	      "& p": {
	        display: "none"
	      },
	      "&:hover": {
	        backgroundColor: theme.colours.palette.blue,
	        color: theme.colours.palette.white,
	        "& img": {
	          display: "none"
	        },
	        "& p": {
	          display: "block",
	          textAlign: "center"
	        }
	      },
	      "&:focus": {
	        backgroundColor: theme.colours.palette.blue,
	        color: theme.colours.palette.white,
	        "& img": {
	          display: "none"
	        },
	        "& p": {
	          display: "block",
	          textAlign: "center"
	        }
	      },
	      "&:active": {
	        backgroundColor: theme.colours.palette.blue,
	        color: theme.colours.palette.white,
	        "& img": {
	          display: "none"
	        },
	        "& p": {
	          display: "block",
	          textAlign: "center"
	        }
	      }
	    },
	    photo: {
	      width: "300px",
	      height: "300px",
	      borderRadius: "150px",
	      display: "inline-block",
	      "@media (max-width: 823px)": {
	        width: "150px",
	        height: "150px",
	        borderRadius: "75px"
	      }
	    },
	    topParagraph: {
	      marginTop: "7rem",
	      marginBottom: 0,
	      "@media (max-width: 823px)": {
	        marginTop: "2.5rem"
	      }
	    },
	    bottomParagraph: {
	      marginTop: 0
	    }
	  };
	};
	
	var FacePhoto = function FacePhoto(_ref) {
	  var classes = _ref.classes,
	      image = _ref.image,
	      employee = _ref.employee,
	      position = _ref.position;
	  return _react2.default.createElement(
	    "div",
	    { className: classes.circle },
	    _react2.default.createElement(
	      "p",
	      { className: classes.topParagraph },
	      employee
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: classes.bottomParagraph },
	      position
	    ),
	    _react2.default.createElement("img", { src: image, className: classes.photo })
	  );
	};
	
	FacePhoto.propTypes = {
	  classes: _propTypes2.default.object,
	  image: _propTypes2.default.string,
	  employee: _propTypes2.default.string,
	  position: _propTypes2.default.string
	};
	
	exports.default = (0, _reactJss2.default)(styles)(FacePhoto);
	module.exports = exports["default"];

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Face-Adam.7a5b9c94.jpg";

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Face-Aidan.fa2dfe0d.jpg";

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Face-Danielle.9c22bb75.jpg";

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Face-Matt.caf62523.jpg";

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Face-Ollie.79b029f5.jpg";

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Face-Sarah.dadeef3e.jpg";

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Face-Sean.813d1174.jpg";

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Face-Simon.8fed9958.jpg";

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.AboutQuery = undefined;
	
	var _Grid = __webpack_require__(5);
	
	var _ContentBlock = __webpack_require__(6);
	
	var _ContentBlock2 = _interopRequireDefault(_ContentBlock);
	
	var _FacePhoto = __webpack_require__(197);
	
	var _FacePhoto2 = _interopRequireDefault(_FacePhoto);
	
	var _HtmlContainer = __webpack_require__(8);
	
	var _HtmlContainer2 = _interopRequireDefault(_HtmlContainer);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextSection = __webpack_require__(7);
	
	var _TextSection2 = _interopRequireDefault(_TextSection);
	
	var _reactJss = __webpack_require__(3);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _FaceSimon = __webpack_require__(492);
	
	var _FaceSimon2 = _interopRequireDefault(_FaceSimon);
	
	var _FaceAidan = __webpack_require__(486);
	
	var _FaceAidan2 = _interopRequireDefault(_FaceAidan);
	
	var _FaceDanielle = __webpack_require__(487);
	
	var _FaceDanielle2 = _interopRequireDefault(_FaceDanielle);
	
	var _FaceSarah = __webpack_require__(490);
	
	var _FaceSarah2 = _interopRequireDefault(_FaceSarah);
	
	var _FaceMatt = __webpack_require__(488);
	
	var _FaceMatt2 = _interopRequireDefault(_FaceMatt);
	
	var _FaceOllie = __webpack_require__(489);
	
	var _FaceOllie2 = _interopRequireDefault(_FaceOllie);
	
	var _FaceSean = __webpack_require__(491);
	
	var _FaceSean2 = _interopRequireDefault(_FaceSean);
	
	var _FaceAdam = __webpack_require__(485);
	
	var _FaceAdam2 = _interopRequireDefault(_FaceAdam);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    content: {
	      height: "100%"
	    },
	    text: {
	      fontSize: "1.3rem",
	      fontWeight: 200,
	      paddingLeft: "5rem",
	      paddingRight: "5rem",
	      marginBottom: "2rem",
	      "@media (max-width: 823px)": {
	        padding: 0,
	        marginLeft: "1rem",
	        marginRight: "1rem",
	        width: "90%",
	        lineHeight: "1.5"
	      },
	      "& h1": {
	        fontSize: "5.4rem",
	        fontWeight: 200,
	        margin: 0,
	        "@media (max-width: 823px)": {
	          fontSize: "3rem"
	        }
	      },
	      "& a": {
	        color: theme.colours.content.fontColor
	      },
	      "& h2": {
	        fontSize: "5.4rem",
	        fontWeight: 200,
	        textAlign: "center",
	        margin: 0,
	        "@media (max-width: 823px)": {
	          fontSize: "3rem"
	        }
	      }
	    },
	    container: {
	      width: "100%"
	    },
	    rowContainer: {
	      maxWidth: "1999px"
	    },
	    center: {
	      display: "flex",
	      justifyContent: "center",
	      alignItems: "center"
	    },
	    meet: {
	      marginTop: "10vh"
	    },
	    about: {
	      width: "1000px",
	      "@media (max-width: 823px)": {
	        width: "90%"
	      }
	    },
	    photoContainer: {
	      width: "33%",
	      display: "flex",
	      justifyContent: "center",
	      alignItems: "center",
	      paddingBottom: "32px",
	      "@media (max-width: 1000px)": {
	        width: "50%"
	      }
	    }
	  };
	};
	
	var AboutPage = function AboutPage(_ref) {
	  var classes = _ref.classes,
	      data = _ref.data;
	  return _react2.default.createElement(
	    "div",
	    { className: classes.content },
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: classes.container },
	        _react2.default.createElement(
	          "div",
	          { className: classes.center },
	          _react2.default.createElement(
	            "div",
	            { className: classes.about },
	            _react2.default.createElement(
	              _TextSection2.default,
	              { className: classes.text },
	              _react2.default.createElement(_HtmlContainer2.default, { content: data.MainContent.html })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.meet },
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.text },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.MeetHeader.html })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.center },
	            _react2.default.createElement(
	              "div",
	              { className: classes.rowContainer },
	              _react2.default.createElement(
	                _Grid.Row,
	                { around: true, wrap: true },
	                _react2.default.createElement(
	                  "div",
	                  { className: classes.photoContainer },
	                  _react2.default.createElement(_FacePhoto2.default, {
	                    image: _FaceSimon2.default,
	                    employee: "Simon",
	                    position: "CEO & Founder"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: classes.photoContainer },
	                  _react2.default.createElement(_FacePhoto2.default, {
	                    image: _FaceAidan2.default,
	                    employee: "Aidan",
	                    position: "Developer"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: classes.photoContainer },
	                  _react2.default.createElement(_FacePhoto2.default, {
	                    image: _FaceSarah2.default,
	                    employee: "Sarah",
	                    position: "Operations Manager"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: classes.photoContainer },
	                  _react2.default.createElement(_FacePhoto2.default, {
	                    image: _FaceMatt2.default,
	                    employee: "Matt",
	                    position: "Head of Marketing"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: classes.photoContainer },
	                  _react2.default.createElement(_FacePhoto2.default, {
	                    image: _FaceOllie2.default,
	                    employee: "Ollie",
	                    position: "Head of Support"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: classes.photoContainer },
	                  _react2.default.createElement(_FacePhoto2.default, {
	                    image: _FaceSean2.default,
	                    employee: "Sean",
	                    position: "Parliamentary Liaison \xA0\xA0\xA0 Australia"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: classes.photoContainer },
	                  _react2.default.createElement(_FacePhoto2.default, {
	                    image: _FaceAdam2.default,
	                    employee: "Adam",
	                    position: "Business Development Manager"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: classes.photoContainer },
	                  _react2.default.createElement(_FacePhoto2.default, {
	                    image: _FaceDanielle2.default,
	                    employee: "Danielle",
	                    position: "Community Engagement & Growth"
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	AboutPage.propTypes = {
	  classes: _propTypes2.default.object,
	  data: _propTypes2.default.object
	};
	
	exports.default = (0, _reactJss2.default)(styles)(AboutPage);
	
	/* global graphql */
	
	var AboutQuery = exports.AboutQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-jsx-ff2ba0315e0faa684e7d.js